export type ProductState = ProductContext & Partial<ProductOrder>

export type ProductStatus =
  | 'uninstalled'
  | 'enabled__mobile_enabled'
  | 'enabled__mobile_disabled'
  | 'disabled__mobile_enabled'
  | 'disabled__mobile_disabled'

export enum ProductOrderState {
  unstarted = 'unstarted',
  checkoutModalLoading = 'checkoutModalLoading',
  checkoutModalOpened = 'checkoutModalOpened',
  orderConfirmationPending = 'orderConfirmationPending',
  ErrorOrderConfirmationTooLong = 'ErrorOrderConfirmationTooLong',
  unknownError = 'unknownError',
  confirmedOrder = 'confirmedOrder',
}

export enum ProductAction {
  configure = 'configure',
  disable = 'disable',
  enable = 'enable',
  install = 'install',
  mobile_disable = 'mobile_disable',
  mobile_enable = 'mobile_enable',
  reset = 'reset',
  uninstall = 'uninstall',
  upgrade = 'upgrade',
  upload = 'upload',
  buy = 'buy',
  reactivate_bc = 'reactivate_bc',
  contact_support = 'contact_support'
}

export enum ProductError {
  default = 'default',
  orderConfirmationTooLong = 'orderConfirmationTooLong',
  validateEmail = 'validateEmail',
}

export interface ProductContextFromPsMboModule {
  config_url: undefined | string
  version: string
  name: string
  status?: ProductStatus
  newInstalled: boolean
}


export enum ScanningState {
  STRICT = 'strict',
  PERMISSIVE = 'permissive',
}

export interface ProductContext {
  configUrl: undefined | string
  installedVersion: string
  name: string
  status?: ProductStatus
  newInstalled: boolean
  installed?: boolean
  error?: ProductError
  loading: ProductAction
  scanning?: ScanningState
}

export interface ProductCategories {
  category: ProductCategory
  categoryParent: ProductCategory
}

export interface ProductCategory {
  id_category: number
  name: string
  english_name: string
}

export interface ProductOrder {
  orderState: ProductOrderState
  purchased: boolean
}

export interface ProductActionResponse {
  config_url: string
  version: string | undefined
  module_status?: ProductStatus
}

export enum SortBy {
  Default = 'revelance',
}

export interface ProductCategoryFromApi {
  categories: ProductCategoryFromApi[]
  gp_category_id: number
  id_category: number
  id_parent: number
  link_rewrite: string
  name: string
  active: number
}

export interface ProductMboCategory {
  isParent: boolean
  childCategoriesId: string[]
  id: string
  parentId: string
  link: string
  name: string
}

export enum CategoriesLoadingState {
  unstarted,
  loading,
  loaded,
  error,
}
